import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { indexOf, each } from 'lodash';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import LogoutPage from '../Auth/pages/LogoutPage/LogoutPage';
import OutcomesPage from '../Analysic/pages/AnalysisPage/AnalysisPage';
import PerformancePage from '../Performance/pages/PerformancePage/PerformancePage';
import ForecastPage from '../Forecast/pages/ForecastPage/Forecast';
import SetupPage from '../Setup/pages/SetupPage/SetupPage';
import NominationsPage from '../Nomination/pages/NominationPage/NominationPage';
import AdminPage from '../Admin/pages/AdminPage/AdminPage';
import NewsPage from '../News/pages/NewsPage/NewsPage';
import PipelinePage from '../Pipeline/pages/PipelinePage/PipelinePage';
import Dashboard from '../Dashboard/pages/DashboardPage/DashboardPage';
import FeedbackPage from '../Feedback/pages/FeedbackPage/FeedbackPage';
import ApexReciver from '../Apex/pages/ApexReceiverPage/ApexReceiverPage';
import ApexRedirectHOC from '../Apex/pages/ApexRedirectPage/ApexRedirectPage';
import NotFoundPage from '../NotFound/pages/NotFoundPage/NotFoundPage';
import TeamPage from '../Team/pages/Teams/TeamsPage';
import Leaderboards from '../Leaderboards/pages/Leaderboards';
import ExcludeOpportunityPage from '../Apex/pages/OpportunityExcludePage/OpportunityExcludePage';
import EmailAlertUnsubscribePage from '../Setup/pages/EmailAlertsPage/EmailAlertUnsubscribePage';

import {
  getUser,
  getIsAdmin,
  getIsPIUser,
  getIsSuperAdmin,
  getUserCurrentOrganization,
  getIsOrganizationAdmin,
  getIsUsingOrganizationSwitch,
  getIsOrganizationManager,
} from '../Auth/AuthReducer';
import getMenus from './components/Header/menu';

const ApexRedirect = ApexRedirectHOC(ApexReciver);
const ApexExcludeOpportunityPage = ApexRedirectHOC(ExcludeOpportunityPage);

const Routes = (props) => {
  const {
    location: { pathname },
    canSeeAllPages,
    userCurrentOrganization,
    isSuperAdmin,
    isAdmin,
    isPIUser,
    isOrganizationAdmin,
    isUsingOrganizationSwitch,
    isOrganizationManager,
    user,
  } = props;

  const menuComps = {
    workspace: Dashboard,
    outcomes: OutcomesPage,
    pipeline: PipelinePage,
    forecast: ForecastPage,
    nominations: NominationsPage,
    performance: PerformancePage,
    feedback: FeedbackPage,
    leaderboards: Leaderboards,
  };
  const items = [];
  let firstPage = null;
  const menus = getMenus(user, userCurrentOrganization, canSeeAllPages);
  each(menus, (menu) => {
    if (!firstPage) {
      firstPage = menu;
    }
    items.push(<Route key={menu.url} path={menu.url} component={menuComps[menu.componentKey]} />);
  });

  items.push(<Route key="news" path="/news" component={NewsPage} />);

  if (
    isSuperAdmin ||
    isAdmin ||
    isOrganizationAdmin ||
    (isPIUser && isUsingOrganizationSwitch)
  ) {
    items.push(<Route key="setup" path="/setup" component={SetupPage} />);
  }
  if (
    isSuperAdmin ||
    isAdmin ||
    isOrganizationAdmin ||
    isOrganizationManager ||
    (isPIUser && isUsingOrganizationSwitch)
  ) {
    items.push(<Route key="teams" path="/teams" component={TeamPage} />);
  }

  if (isSuperAdmin || isAdmin) {
    items.push(<Route key="admin" path="/admin" component={AdminPage} />);
  }

  items.push(<Route key="logout" path="/logout" component={LogoutPage} />);

  items.push(<Route key="unsubscribe-email-alert" path="/unsubscribe/email-alert" component={EmailAlertUnsubscribePage} />);  // This page works regardless of login status.


  // this NEED to come before
  items.push(<Route key="exclude-opportunity-redirect-1" path="/request-feedback/:type(force|azure|hubspot)/organizations/:organizationId/exclude-:source(accounts|opportunities)/:resourceId" component={ApexExcludeOpportunityPage} />);
  items.push(<Route key="exclude-opportunity-redirect" path="/request-feedback/organizations/:organizationId/exclude-opportunities/:resourceId" component={ApexExcludeOpportunityPage} />);

  // items.push(<Route key="exclude-opportunity" path="/request-feedback/exclude-opportunities/:opportunityId" component={ExcludeOpportunityPage} />);

  // items.push(<Route key="apex-redirect" path="/apex/organizations/:organizationId/opportunities/:opportunityId" component={ApexRedirect} />);
  // items.push(<Route key="apex" path="/apex/:opportunityId" component={ApexReciver} />);
  items.push(<Route key="request-feedback-redirect-1" path="/request-feedback/:type(force|azure|hubspot)/organizations/:organizationId/:source(accounts|opportunities)/:resourceId" component={ApexRedirect} />);
  items.push(<Route key="request-feedback-redirect" path="/request-feedback/organizations/:organizationId/:source(accounts|opportunities)/:resourceId" component={ApexRedirect} />);

  // items.push(<Route key="request-feedback" path="/request-feedback/opportunities/:opportunityId" component={ApexReciver} />);

  if (pathname === '/') {
    // redirect to first available page
    if (firstPage) {
      items.push(<Redirect key="redirect" to={firstPage.url} />);
    } else {
      items.push(<Redirect key="redirect" to="/not-found" />);
    }
  }
  // very important: this has to be the last item! even after <Redirect />
  items.push(<Route key="notFound" component={NotFoundPage} />);


  return (
    <Switch>
      {items}
    </Switch>
  );
};
Routes.propTypes = {
  location: PropTypes.shape({}).isRequired,
  canSeeAllPages: PropTypes.bool,
  isSuperAdmin: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isPIUser: PropTypes.bool,
  user: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  isOrganizationAdmin: PropTypes.bool,
  isUsingOrganizationSwitch: PropTypes.bool,
  isOrganizationManager: PropTypes.bool,
  userCurrentOrganization: PropTypes.shape({
    features: PropTypes.shape({
      dashboard: PropTypes.bool,
      forecast: PropTypes.bool,
      outcomes: PropTypes.bool,
      performance: PropTypes.bool,
      pipeline: PropTypes.bool,
      nominations: PropTypes.bool,
    }),
  }),
};
Routes.defaultProps = {
  canSeeAllPages: false,
  isSuperAdmin: false,
  isAdmin: false,
  isPIUser: false,
  isOrganizationAdmin: false,
  isUsingOrganizationSwitch: false,
  userCurrentOrganization: null,
  isOrganizationManager: false,
};
function mapStateToProps(state) {
  const user = getUser(state);
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  let canSeeAllPages = false;
  if (isAdmin || isSuperAdmin) {
    canSeeAllPages = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canSeeAllPages = true;
  }

  return {
    user,
    userCurrentOrganization,
    canSeeAllPages,
    isSuperAdmin,
    isOrganizationAdmin: getIsOrganizationAdmin(state),
    isUsingOrganizationSwitch: getIsUsingOrganizationSwitch(state),
    isOrganizationManager: getIsOrganizationManager(state),
    isAdmin,
    isPIUser,
  };
}

export default connect(mapStateToProps)(withRouter(Routes));
